import { useDispatch, useSelector } from "react-redux";
import { downloadRefPriceReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { TradingData  } from "../types";

export const useRefPriceReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.tradingData.downloadReportFetchState
  );

  const data = useSelector<StoreType, TradingData[] | undefined>(
    s => s.data.clearing.tradingData.currentPage?.currentPageData
  );
  
  const hasData = (data !== undefined && data !== null && data.length > 0) ;

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadRefPriceReport()),
    [dispatch]
  );

  return [download, fetchState, hasData] as [typeof download, typeof fetchState, typeof hasData];
};




